// extracted by mini-css-extract-plugin
module.exports = {"proteinQa":"Faq_proteinQa__EyMWR","proteinMarkpen":"Faq_proteinMarkpen__v0Rng","image":"Faq_image__pRl88"};